;(function() {

	var NestedFormFields = {};

	NestedFormFields.add = function(objectClass, associationPath, scope, insertIntoId) {
		var addedIndex = document.querySelectorAll(".nested_" + associationPath).length;

		document.trigger("nestedformfieldsadding", { objectClass: objectClass, addedIndex: addedIndex, associationPath: associationPath });

		var template = null;
		if (scope) {
			template = document.querySelector(scope + " #" + associationPath + "_template");
		}
		else{
			template = document.querySelector("#" + associationPath + "_template");
		}
		var templateHtml = template.innerHTML;

	    // insert association indexes
	    var indexPlaceholder = "__" + associationPath + "_index__";
	    templateHtml = templateHtml.replace(new RegExp(indexPlaceholder, "g"), addedIndex);

		// look for replacements in user defined code and substitute with the index
		templateHtml = templateHtml.replace(new RegExp("__nested_field_for_replace_with_index__", "g"), addedIndex);

	    // replace child template div tags with script tags to avoid form submission of templates
	    var parsedTemplate = document.createElement('div');
	    parsedTemplate.innerHTML = templateHtml.trim();
	    parsedTemplate = parsedTemplate.firstChild;

	    // $parsedTemplate = $(templateHtml)
	    // $child_templates = $parsedTemplate.closestChild('.form_template')
	    // $child_templates.each () ->
	    //   $child = $(this)
	    //   $child.replaceWith($("<script id='#{$child.attr('id')}' type='text/html' />").html($child.html()))

	    if (insertIntoId) {
	    	document.querySelector("#" + insertIntoId).append(parsedTemplate);
	    }
	    else {
	    	template.parentNode.insertBefore(parsedTemplate, template);
	    }

	    parsedTemplate.setAttribute("data-added-index", addedIndex);
	    parsedTemplate.trigger("nestedformfieldsadded", { objectClass: objectClass, nestedFieldsContainer: parsedTemplate, addedIndex: addedIndex, associationPath: associationPath, event: event });

	    return parsedTemplate;
	};


	document.addEventSelectorListener("click", ".add_nested_fields_link", function(event, target) {
		event.preventDefault();

	    NestedFormFields.add(
	    	target.getAttribute("data-object-class"),
	    	target.getAttribute("data-association-path"),
	    	target.getAttribute("data-scope"),
	    	target.getAttribute("data-insert-into")
	    );

	    return false;
	});



	document.addEventSelectorListener("click", ".remove_nested_fields_link", function(event, target) {
		event.preventDefault();

		if (target.getAttribute("disabled")) {
			return;
		}

		var objectClass = target.getAttribute("data-object-class");
		var deleteAssociationFieldName = target.getAttribute("data-delete-association-field-name");
		removedIndex = parseInt(deleteAssociationFieldName.match('(\\d+\\]\\[_destroy])')[0].match('\\d+')[0]);
		var nestedFieldsContainer = target.closest(".nested_fields");

		document.trigger("nestedformfieldsremoving", { objectClass: objectClass, nestedFieldsContainer: nestedFieldsContainer, deleteAssociationFieldName: deleteAssociationFieldName, removedIndex: removedIndex });


		var delete_field = nestedFieldsContainer.querySelector("input[type='hidden'][name='" + deleteAssociationFieldName + "']");
		if (delete_field) {
			delete_field.value = 1;
		}
		else {
			var input = document.createElement("input");
			input.setAttribute("type", "hidden");
			input.setAttribute("name", deleteAssociationFieldName);
			input.setAttribute("value", 1);
			nestedFieldsContainer.prepend(input);
		}

		nestedFieldsContainer.style.display = "none";
		var elements = nestedFieldsContainer.querySelectorAll("input[required], select[required], textarea[required]");
		for (var i = 0; i < elements.length; ++i) {
			elements[i].removeAttribute("required");
		}

		nestedFieldsContainer.trigger("nestedformfieldsremoved", { objectClass: objectClass, nestedFieldsContainer: nestedFieldsContainer, deleteAssociationFieldName: deleteAssociationFieldName, removedIndex: removedIndex });

		return false;
	});



	// *************************************************************************
	// Publish
	// *************************************************************************

	window.NestedFormFields = NestedFormFields;

}());